<mat-card class="cmn-flex column">
<app-form-container class="spaced-bottom-lg">
    <div class="form-area-header">
        <div class="div cmn-flex row align-center gutters-sm">
            <mat-icon>vpn_key</mat-icon>
            <h3 class="compact">Create API Key</h3>
        </div>
    </div>
    <form [formGroup]="newApiKey" class="cmn-flex flex column">
        <div class="cmn-flex row align-start gutters">
            <app-section-container header="Name*" [error]="newApiKey.get('name').touched && newApiKey.get('name').invalid" class="flex">
                <input matInput
                       formControlName="name"
                       name="name"
                       class="no-style"
                       required
                       autocomplete="off" />
            </app-section-container>
            <app-section-container header="Expiration Date{{ isExpirationRequired() ? '*' : '' }}"
                                   class="compact flex"
                                   [subsequentMessage]="expirationHelpText"
                                   [error]="error">
                <input matInput formControlName="expiration" [matDatepicker]="picker" class="flex no-style" [min]="minDate" [max]="maxDate" (input)="setMessage()">
                <mat-datepicker-toggle matSuffix [for]="picker" class="custom-toggle color-white-when-dark-mode"></mat-datepicker-toggle>
            </app-section-container>
            <app-info-message [message]="inactivityMessage" class="flex"></app-info-message>
        </div>
        <div class="cmn-flex row justify-end gutters">
            <button mat-raised-button color="accent" (click)="createKey()" class="createBtn">Create New API Key</button>
        </div>
    </form>
</app-form-container>

<app-form-container class="spaced-bottom-lg">
    <div class="form-area-header">
        <div class="div cmn-flex row align-center gutters-sm">
            <mat-icon>vpn_key</mat-icon>
            <h3 class="compact">Your API Keys</h3>
        </div>
    </div>
    <ng-container *ngIf="apiKeys.length; else noKeys">
        <div *ngFor="let key of apiKeys; let last=last" class="grid-container cmn-border-top padded-left" [ngClass]="{'cmn-border-bottom': last}">
            <div class="ellipsis">{{ key.name }}</div>
            <div class="cmn-flex row">
                <div class="cmn-label-value">Created On Date:</div>
                <div class="ellipsis">{{ key.issued_at | date: 'short'}}</div>
            </div>
            <div class="cmn-flex row">
                <div class="cmn-label-value">Expiration Date:</div>
                <div class="ellipsis">{{ key.expires_at | date: 'short'}}</div>
            </div>
            <div class="cmn-flex row align-center">
                <div class="cmn-label-value">Last Used:</div>
                <div class="ellipsis">{{ key.last_used ? ( key.last_used | date: 'short') : 'N/A'}}</div>
                <div *ngIf="isAboutToExpire(key)" class="spaced-left cmn-flex flex row align-center">
                    <mat-icon fontSet="material-icons-outlined"
                              [color]="isExpired(key) ? 'error' : 'warn'"
                              matTooltip="{{ getKeyWarningMessage(key) }}">
                        {{ isExpired(key) ? "error_outline" : "report_problem" }}
                    </mat-icon>
                </div>
            </div>
            <button mat-button class="camelCase" (click)="revokeKey(key)">
                <div class="cmn-flex row align-center gutters-sm">
                    <span>Revoke</span>
                    <mat-icon color="error">vpn_key_off</mat-icon>
                </div>
            </button>
        </div>
    </ng-container>
</app-form-container>
<div *ngIf="apiKeys.length" class="padded">{{ apiKeys.length }} total</div>

<mat-datepicker #picker></mat-datepicker>

<ng-template #noKeys>
    <mat-progress-bar *ngIf="initializing" mode="indeterminate"></mat-progress-bar>
    <app-no-resources *ngIf="!initializing" resource="API Keys"></app-no-resources>
</ng-template>
</mat-card>

